import { createReducer, on } from '@ngrx/store';
import * as ArkikProductsActions from './arkik-products.actions';
import { ArkikProductsState } from './arkik-products.models';

export const initialState: ArkikProductsState = {
  products: null,
  loading: false,
  error: null,
};

export const arkikProductsReducer = createReducer(
  initialState,
  on(ArkikProductsActions.loadArkikProducts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ArkikProductsActions.loadArkikProductsSuccess, (state, { products }) => ({
    ...state,
    loading: false,
    error: null,
    products,
  })),
  on(ArkikProductsActions.loadArkikProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ArkikProductsActions.resetArkikProducts, () => initialState),
);
